import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { error } from 'protractor';
import { NgxSpinnerService } from "ngx-spinner";
import { resolve } from 'url';
import * as CryptoJS from 'crypto-js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';
import * as XLSX from 'xlsx';

import * as _ from 'lodash';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationApprovalDialogComponent } from 'src/app/components/confirmation-approval-dialog/confirmation-approval-dialog.component';
import { ConfirmationWarningDialogComponent } from 'src/app/components/confirmation-warning-dialog/confirmation-warning-dialog.component'
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  userRoles;
  classList = [];
  defaultPassword;
  userId;
  operationValue;
  secretKey = "Ge^3%kanLas&1@j!";
  encryptSecretKey = CryptoJS.enc.Utf8.parse('Ge^3%kanLas&1@j!');
  vector = CryptoJS.enc.Utf8.parse('Jha&82u)9G!lh#jp');

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';


  //addition by rahul for whos-who api
  apiCheckFlag = true;



  constructor(
    private sanitizer: DomSanitizer,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  setLocalStorageItem(key, value) {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.setItem(key, value);
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  getLocalStorageItem(key) {
    console.log('Calling local storage', key);
    return new Promise((resolved, reject) => {
      try {
        let resJson = JSON.parse(sessionStorage.getItem(key));
        resolved(resJson);
      } catch (e) {
        reject(e);
      }
    });
  }

  clearLocalStorageItem(key) {
    return new Promise((resolve, reject) => {
      try {
        sessionStorage.removeItem(key);
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  separateTimeAndTimeFormat(str: string, delimeter: string): any[] {
    if (typeof str === undefined) {
      return [];
    } else {
      return str.split(delimeter);
    }
  }

  convertDateToTimeFormat(date: string): string {
    var recievedDate = new Date(date);
    var options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    return recievedDate.toLocaleString('en-US', options);
  }

  setLocalStorage(key, value) {
    sessionStorage.setItem(key, value);
  }

  showLoader() {
    this.spinnerService.show();
  }

  hideLoader() {
    this.spinnerService.hide();
  }

  showSuccess(message) {
    this.toastr.success(message, 'Success!', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }
  showSuccessIfo(message, msg) {
    var b = 'userId -  '
    var a = '\n Password -abc123\n'
    this.toastr.success(`${b}${msg}${a}${message}`, `Success! `, {
      timeOut: 50000,
      positionClass: 'toast-top-right'
    });
  }

  showInfo(message) {
    this.toastr.info(message, 'Info!', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }


  showWarning(message) {
    this.toastr.warning(message, 'Warning !', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message) {
    this.toastr.error(message, 'Error!', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }

  showMsg(message) {
    this.toastr.warning(message, 'No Images', {
      timeOut: 3000,
      positionClass: 'toast-top-right'
    });
  }

  setPassword(password) {
    this.defaultPassword = password;
  }

  setUserId(id) {
    this.userId = id;
  }

  getPassword() {
    return this.defaultPassword;
  }

  getUserId() {
    return this.userId;
  }

  setValue(val) {
    this.operationValue = val
  }

  getValue() {
    return new Promise((resolve, reject) => {
      try {
        let resJson = this.operationValue;
        resolve(resJson);
      } catch (e) {
        reject(e);
      }
    });
    // return this.operationValue
  }

  formatDate<T>(val, formaTType) {
    return new Promise((resolve, reject) => {
      try {
        var selectedDate;
        if (val !== null && val.year) {
          selectedDate = val.year + "-" + val.month + "-" + val.day
        } else {
          selectedDate = val
        }
        if (moment(selectedDate, formaTType).isValid()) {
          resolve(selectedDate)
        } else {
          reject();
        }
      } catch (error) {
      }
    })
  }

  formatTodayDate<T>(today) {
    return new Promise((resolve, reject) => {
      try {
        var selectedDate;
        let month;
        let day;
        if (today !== null) {
          if (Number(today.getMonth()) + 1 < 10) {
            month = '0' + (Number(today.getMonth()) + 1)
          } else {
            month = Number(today.getMonth()) + 1
          }
          if (today.getDate() < 10) {
            day = '0' + today.getDate()
          } else {
            day = today.getDate()
          }
          selectedDate = today.getFullYear() + '-' + month + '-' + day;
        }
        if (selectedDate) {
          resolve(selectedDate)
        } else {
          reject();
        }
      } catch (error) {
      }
    })
  }

  searchFromArray<T>(searchedArray, searchedKey, searchedValue) {
    return new Promise((resolve, reject) => {
      try {
        const response = searchedArray.find(val => val.searchedKey === searchedValue);
        if (response != null && response != undefined) {
          resolve(response)
        } else {
          reject();
        }
      } catch (error) {
      }
    })
  }

  loaderWithTimer() {
    // this.spinnerService.show(setTimeout(() => {

    // }, 500);;
    // )}
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide()
    }, 20000);
  }

  clearAllLocalStorage() {
    sessionStorage.clear();
  }

  getUserRole() {
    return this.userRoles;
  }

  setUserRole(roles) {
    this.userRoles = roles;
  }

  generateClassList(group) {
    this.classList = [];
    return new Promise((resolve, reject) => {
      try {
        for (let i = 0; i < 45; i++) {
          const classObj = {
            id: i + group,
            class: i + 1
          }
          this.classList.push(classObj)
        }
        if (this.classList.length == 45) {
          resolve(this.classList);
        }
      } catch (error) {

      }
    })
  }

  formatMMDDYYYY(reqDate) {
    let dateArray = reqDate.split('-')
    let date = new Date(dateArray[1] + "/" + dateArray[0] + "/" + dateArray[2]);
    return moment(date).format("MM/DD/yyyy")
  }

  aesEncryption(input) {
    return CryptoJS.AES.encrypt(JSON.stringify(input), this.encryptSecretKey, {
      iv: this.vector,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }

  aesDecryption(input) {
    return CryptoJS.AES.decrypt(input, this.encryptSecretKey, {
      iv: this.vector,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);

    var range = XLSX.utils.decode_range(worksheet['!ref']);
    for (var C = range.s.r; C <= range.e.c; ++C) {
      var address = XLSX.utils.encode_col(C) + '1'; // <-- first row, column number C
      console.log('address', address);
      if (!worksheet[address]) continue;
      worksheet[address].v = worksheet[address].v.toUpperCase()
      console.log('worksheet[address].v', worksheet[address].v);

      //  worksheet[address].v = worksheet[address].v.fontcolor("#279377")
      //worksheet[address].v =  worksheet[address].v.fontcolor("#279377")
      //worksheet[address].v = worksheet[address].v.replace({ fontWeight: 'bold', fontSize: '12pt', backgroundColor: '#279377', textAlign: 'center',})
    }


    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);

  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + this.EXCEL_EXTENSION);
  }




  exportExcel(excelData) {

    console.log('excelData', excelData);

    //Title, Header & Data
    const title = excelData.title;
    const header = excelData.headers
    const data = excelData.data;

    //Create a workbook with a worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('report');

    //Blank Row 
    // worksheet.addRow([]);

    //Adding Header Row
    let headerRow = worksheet.addRow(header);

    console.log('headerRow', headerRow);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffffa7' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: '000000' },
        size: 12
      }
    })



    // Adding Data with Conditional Formatting
    data.forEach(d => {
      worksheet.addRow(d);
    }
    );

    // data.forEach(d => {
    //   let row = worksheet.addRow(d);

    //   let sales = row.getCell(6);
    //   let color = 'FF99FF99';
    //   // if (+sales.value < 200000) {
    //   //   color = 'FF9999'
    //   // }

    //   sales.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: color }
    //   }
    // }
    // );

    // worksheet.getColumn(3).width = 20;
    // worksheet.addRow([]);



    //Generate & Save Excel File
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    })

  }








  confirm(
    title: string,
    message: string,
    dialogSize): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, {
      size: dialogSize, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = 'OK';
    modalRef.componentInstance.btnCancelText = 'Cancel';
    return modalRef.result;
  }

  confirmApproval(
    title: string,
    subMessage: string,
    message: string,
    dialogSize): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationApprovalDialogComponent, {
      size: dialogSize, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.subMessage = subMessage;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = 'OK';
    modalRef.componentInstance.btnCancelText = 'Cancel';
    return modalRef.result;
  }

  confirmWarning(
    title: string,
    message: string,
    dialogSize): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationWarningDialogComponent, {
      size: dialogSize, backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = 'OK';
    modalRef.componentInstance.btnCancelText = 'Cancel';
    return modalRef.result;
  }


  deleteFromArray(array, obj) {
    this.classList = [];
    return new Promise((resolve, reject) => {
      try {
        const index = array.indexOf(obj);
        if (index > -1) {
          array.splice(index, 1);
          resolve(this.classList);
        }
      } catch (error) {

      }
    })
  }


  //addition by Rahul
  setApiStatus(val) {
    this.apiCheckFlag = val;
    console.log('setApiStatus:', val)

  }

  getApiStatus() {

    return new Promise((resolve, reject) => {

      try {

        let resJson = this.apiCheckFlag;

        resolve(resJson);
        console.log('getApiStatus:', resJson)

      } catch (e) {

        reject(e);

      }

    });

    // return this.operationValue

  }



}
